(() => {
  const HISTORY_ID = 'size-sheet';
  const drawer = () => document.getElementById('IGSizeDrawer');
  let selectedVariantId = null;

  const productUrlWithVariant = (url, id) => {
    if (!url) return null;
    return `${url}${url.indexOf('?') === -1 ? '?' : '&'}variant=${id}`;
  };

  const open = (btn) => {
    const d = drawer();
    if (!d) return;
    selectedVariantId = null;
    const sizes = safeParse(btn.dataset.sizes);
    const list = d.querySelector('[data-ig-drawer-sizes]');
    const cta = d.querySelector('[data-ig-drawer-add]');
    if (!list || !cta) return;

    // Without quick add the sheet is a size picker that navigates to the product
    // with the variant preselected, so the sizes become links and the CTA goes away.
    const quickAdd = btn.dataset.quickAdd !== 'false';
    const productUrl = btn.dataset.productUrl;

    list.innerHTML = '';
    sizes.forEach((s) => {
      const li = document.createElement('li');
      let el;
      if (quickAdd || !s.available || !productUrl) {
        el = document.createElement('button');
        el.type = 'button';
        el.dataset.variantId = s.id;
        if (!s.available) el.setAttribute('disabled', '');
      } else {
        el = document.createElement('a');
        el.href = productUrlWithVariant(productUrl, s.id);
      }
      el.className = 'ig-size-drawer__size';
      el.textContent = s.value;
      li.appendChild(el);
      list.appendChild(li);
    });

    cta.hidden = !quickAdd;
    cta.setAttribute('disabled', '');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('ig-drawer-open');

    // Ver `ig-overlay-history.js`: el gesto de volver cierra el panel en vez de
    // salir de la pagina.
    if (window.IGOverlayHistory) {
      window.IGOverlayHistory.push(HISTORY_ID, () => close({ fromHistory: true }));
    }
  };

  const close = (options) => {
    const d = drawer();
    if (!d) return;
    const estabaAbierto = d.getAttribute('aria-hidden') === 'false';
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('ig-drawer-open');
    selectedVariantId = null;
    if (estabaAbierto && window.IGOverlayHistory && !(options && options.fromHistory)) {
      window.IGOverlayHistory.pop(HISTORY_ID);
    }
  };

  const selectSize = (btn) => {
    const d = drawer();
    if (!d) return;
    d.querySelectorAll('.ig-size-drawer__size').forEach((el) => el.removeAttribute('data-selected'));
    btn.setAttribute('data-selected', 'true');
    selectedVariantId = btn.dataset.variantId;
    const cta = d.querySelector('[data-ig-drawer-add]');
    if (cta) cta.removeAttribute('disabled');
  };

  const addToCart = async (variantId, trigger) => {
    if (!variantId) return;
    if (trigger) trigger.setAttribute('disabled', '');
    const cartDrawer = document.querySelector('cart-drawer');
    try {
      const body = { items: [{ id: Number(variantId), quantity: 1 }] };
      // cart-drawer.js repaints itself from `response.sections`, so the add has to
      // ask for them up front — otherwise the drawer opens on its stale (empty) markup.
      if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
        body.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
      }

      const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || 'cart_add_failed');

      document.dispatchEvent(new CustomEvent('ig:cart:updated'));
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'ig-size-drawer', productVariantId: variantId });
      }
      close();

      if (cartDrawer && typeof cartDrawer.renderContents === 'function' && data.sections) {
        cartDrawer.classList.remove('is-empty');
        cartDrawer.renderContents(data);
      } else if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open();
      } else {
        window.location = (window.routes && window.routes.cart_url) || '/cart';
      }
    } catch (e) {
      // keep the sheet open so the visitor can retry
    } finally {
      if (trigger) trigger.removeAttribute('disabled');
    }
  };

  const safeParse = (str) => {
    try { return JSON.parse(str) || []; } catch { return []; }
  };

  document.addEventListener('click', (e) => {
    const plus = e.target.closest('.ig-card__plus');
    if (plus) {
      e.preventDefault();
      e.stopPropagation();
      open(plus);
      return;
    }

    // Desktop hover strip. Only the quick-add variant renders a <button> with an
    // id; the link variant is a plain <a> and navigates on its own.
    const cardSize = e.target.closest('.ig-card__size[data-variant-id]');
    if (cardSize) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(cardSize.dataset.variantId, cardSize);
      return;
    }

    if (e.target.closest('[data-ig-drawer-close]')) {
      e.preventDefault();
      close();
      return;
    }
    const sizeBtn = e.target.closest('button.ig-size-drawer__size:not([disabled])');
    if (sizeBtn) {
      e.preventDefault();
      selectSize(sizeBtn);
      return;
    }
    const cta = e.target.closest('[data-ig-drawer-add]:not([disabled])');
    if (cta) {
      e.preventDefault();
      addToCart(selectedVariantId, cta);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const d = drawer();
      if (d && d.getAttribute('aria-hidden') === 'false') close();
    }
  });
})();
